import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let StatesFlowRestServiceConfig: IRestfulConfigMap = {
    "StatesFlowRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取所有状态流转
            // getBranch
            getBranch: {
                method: "get",
                path: "api/partner/flowInstances/entity/:endityId/stateInstances/branch",
                testPath: "api/partner/flowInstances/entity/:endityId/stateInstances/branch",
                paramDefaults: {
                    endityId: "@endityId"
                }
            },
            // 获取当前已完成的状态流转
            // getBranched
            getBranched: {
                method: "get",
                path: "api/partner/flowInstances/entity/:endityId/stateInstances",
                testPath: "api/partner/flowInstances/entity/:endityId/stateInstances",
                paramDefaults: {
                    endityId: "@endityId"
                }
            },
            // 取消
            cancel: {
                method: "post",
                path: "api/partner/flowInstances/entity/:endityId/stateInstances",
                testPath: "api/partner/flowInstances/entity/:endityId/stateInstances",
                paramDefaults: {
                    endityId: "@endityId"
                }
            },
            // 提交退货申请快递信息
            submitExpress: {
                method: "post",
                path: "api/partner/flowInstances/entity/:endityId/stateInstances",
                testPath: "api/partner/flowInstances/entity/:endityId/stateInstances",
                paramDefaults: { 
                    endityId: "@endityId"
                 }
            },
            // 获取指定流程所有状态(退后申请)
            getStateNodes: {
                method: "get",
                path: "api/stateFlows/stateNodes/latest?module=return_request_order",
                testPath: "api/stateFlows/stateNodes/latest?module=return_request_order"
            }
        }
    }
}

export { StatesFlowRestServiceConfig };